import {
  FillInTheBlankOption,
  FillInTheBlankOptionCreateDTO,
  OrderingItem,
  PositionalItem,
  QuizAnswer,
  QuizAnswerCreateDTO,
  QuizAnswerTypeEnum,
} from './Answer';
import { Feedback, FeedbackCreateDTO } from './Feedback';
import { Model, Ordenable } from './Model';
import { TranslatableField } from './TranslatableField';

export enum QuestionTypeEnum {
  FILL_IN_THE_BLANK = 'FILL_IN_THE_BLANK',
  QUIZ = 'QUIZ',
  TEXT = 'TEXT',
  CODE = 'CODE',
  TRUE_OR_FALSE = 'TRUE_OR_FALSE',
  DND_ORDENATION = 'DND_ORDENATION',
  DND_POSITIONAL = 'DND_POSITIONAL',
  WRITING = 'WRITING',
  CODE_EDITOR = 'CODE_EDITOR',
  BLOCK = 'BLOCK',
  FLASHCARD = 'FLASHCARD',
}

export interface Question extends Model, Ordenable {
  title: TranslatableField;
  context?: TranslatableField;
  type: QuestionTypeEnum;
  identifier: string;
  activity: number;
  activitiesIds?: number[];
  feedbacks?: Feedback[];
}
//eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface TextQuestion extends Question {}

export interface TrueOrFalseQuestion extends Question {
  isTrue: boolean;
}

export enum FlowColumn {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}
export interface OrderingColumn extends Model {
  name: string;
  flow: FlowColumn;
  items: OrderingItem[];
}

export interface FlashcardQuestion extends Question {
  frontContent: TranslatableField;
  backContent: TranslatableField;
  showFrontOnBack: boolean;
}

export interface DNDOrdenationQuestion extends Question {
  columns: OrderingColumn[];
}

export enum DnDColumnType {
  QUESTION = 'QUESTION',
  ANSWER = 'ANSWER',
}

export interface PositionalColumn extends Model {
  name: string;
  flow: FlowColumn;
  type: DnDColumnType;
  items: PositionalItem[];
}

export interface DNDPositionalQuestion extends Question {
  questionColumn: PositionalColumn;
  answerColumn: PositionalColumn;
}

export interface QuizQuestion extends Question {
  answerType: QuizAnswerTypeEnum;
  quizAnswers: QuizAnswer[];
}

//eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface WritingQuestion extends Question {}

export interface FillInTheBlankQuestion extends Question {
  question: string;
  options: FillInTheBlankOption[];
}

// DTOs

export type QuizCreateDTO = Omit<
  QuizQuestion,
  'id' | 'quizAnswers' | 'feedbacks'
> & {
  quizAnswers: QuizAnswerCreateDTO[];
  feedbacks?: FeedbackCreateDTO[];
};
export type OrderingQuestionCreateDTO = Omit<
  DNDOrdenationQuestion,
  'id' | 'columns' | 'feedbacks'
> & {
  feedbacks?: FeedbackCreateDTO[];
};
export type PositionalQuestionCreateDTO = Omit<
  DNDPositionalQuestion,
  'id' | 'questionColumn' | 'answerColumn' | 'feedbacks'
> & {
  feedbacks?: FeedbackCreateDTO[];
};
export type FillInTheBlankQuestionCreateDTO = Omit<
  FillInTheBlankQuestion,
  'id' | 'options' | 'feedbacks'
> & {
  options: FillInTheBlankOptionCreateDTO[];
  feedbacks?: FeedbackCreateDTO[];
};

export type TrueOrFalseDTO = Partial<
  Omit<TrueOrFalseQuestion, 'id' | 'feedbacks'>
> & {
  feedbacks?: FeedbackCreateDTO[];
};

export type TextQuestionDTO = Partial<
  Omit<TextQuestion, 'id' | 'feedbacks'>
> & {
  feedbacks?: FeedbackCreateDTO[];
};

export type FlashcardQuestionDTO = Partial<
  Omit<FlashcardQuestion, 'id' | 'feedbacks'>
> & {
  feedbacks?: FeedbackCreateDTO[];
};

/* TODO: Implementar isso quando fizer a parte de CodeQuestion no modal de criação */
//eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface CodeQuestion extends Question {}

/* TODO: Implementar isso quando fizer a parte de BlockCodeQuestion no modal de criação */
//eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface BlockCodeQuestion extends Question {}
